// extracted by mini-css-extract-plugin
export default {"more":"more_more__kipUl"};